// ************** fronto.title.js **************
// concerns "generating" titles (revised for Fronto)
// should be stand-alone (no dependency on the other JS files, but on d3)

import * as d3 from 'd3';
import * as Fronto from "./utility.js";

export function frontoTitleGenerator(placeSelector, titleSpec, viewname, dblClick) {
  // color Control
  function getRGBA(colorExpr, opacity) {
    let cObj;
    if (colorExpr) cObj = d3.color(colorExpr);
    else cObj = d3.color("#222222");
    if (opacity !== undefined && !isNaN(opacity) && opacity !== null) cObj.opacity = opacity;
    return "rgba(" + cObj.r + "," + cObj.g + "," + cObj.b + "," + cObj.opacity + ")";
  }
  // deals numbering counter
  if (d3.select(placeSelector).node(0).childNodes.length == 0)
    d3.select(placeSelector).insert("div", ":first-child");
  let titleArea = d3.select(placeSelector + " div");

  // titleArea.style("padding-bottom", "15px");
  titleArea.style("position", "relative");
  titleArea.style("data-role", "title");
  titleArea.style("font-size", "14px");
  let titleElements = titleArea.selectAll("div").data(titleSpec).join("div");
  titleElements.attr("name", (d) => d.name);
  // direct manipulation setup
  titleElements.attr("class", (d) => d.className);
  titleElements.on("dblclick", (event) => { dblClick(event) });
  // "box>width": {"type": "number"}
  titleElements.style("width", (d) => (d.box?.width ? Fronto.unitString(d.box.width, "px") : "auto"));
  // "box>algin": {"type":  ["left", "center", "right"]}
  titleElements.style("margin-left", (d) => (d.box?.align === "left" ? 0 : "auto"));
  titleElements.style("margin-right", (d) => (d.box?.align === "right" ? 0 : "auto"));
  titleElements.style("margin-bottom", (d) => (d.box?.marginBottom !== undefined ? Fronto.unitString(d.box.marginBottom, "px") : "15px"));
  titleElements.html((d) => d.text?.value);
  titleElements.attr("data-role", "title");
  // "text>size": { "type": "number" },
  titleElements.style("font-size", (d) => {
    // special for numbering
    return d.text?.size !== undefined ? d.text.size + "px" : "14px";
  });
  // "text>lineHeight": { "type": "number", "helpString": "Unit: %" },
  titleElements.style("line-height", (d) => (d.text?.lineHeight !== undefined ? Fronto.unitString(d.text.lineHeight, "%") : d.externalize?.numbering === "yes" ? "100%" : "120%"));
  // "text>color": { "type": "text"},
  // "text>opacity": { "type": "number" },
  titleElements.style("color", (d) => {
    return getRGBA(d.text?.color, d.text?.opacity);
  });
  // "text>align": { "type": ["left", "center", "right"] },
  titleElements.style("text-align", (d) => {
    // special for numbering
    if (d.externalize?.numbering === "yes" && !d.box?.align) return "center";
    else return d.text?.align !== undefined ? d.text.align : "left";
  });
  // "text>weight": { "type": [100, 200, 300, 400, 500, 600, 700, 800, 900] },
  titleElements.style("font-weight", (d) => {
    // special for numbering
    if (d.externalize?.numbering === "yes" && !d.box?.weight) return 700;
    else return d.text?.weight !== undefined ? d.text.weight : 400;
  });
}
